import Hotjar from "@hotjar/browser";

import { hotjarSiteId, hotjarVersion } from "shared/data/Hotjar";
import { isLocalDev, isTest } from "shared/utils/config";
import type { UserId } from "shared/types/User";

export function initHojar() {
  if (isLocalDev || isTest) {
    console.log("Hotjar is disabled in local development.");
    return;
  }

  Hotjar.init(hotjarSiteId, hotjarVersion);
}

let existingHotjarUserId: UserId | null = null;

export const setHotjarUserId = (userId: UserId | null) => {
  if (isLocalDev || isTest || !Hotjar.isReady()) {
    return;
  }
  const isDifferent = existingHotjarUserId !== userId;

  if (isDifferent && userId !== null) {
    existingHotjarUserId = userId;
    Hotjar.identify(userId, {});
  }
};
